const panelRoots = ['/support', '/dashboard', '/settings', '/requests', '/user-profile/company-settings', '/user-profile/company-registration']
export const isPanelHelpRoute = path => panelRoots.some(root => path === root || path.startsWith(`${root}/`))
